import { render, staticRenderFns } from "./serbestfatura.vue?vue&type=template&id=915feb9a&"
import script from "./serbestfatura.vue?vue&type=script&lang=js&"
export * from "./serbestfatura.vue?vue&type=script&lang=js&"
import style0 from "./serbestfatura.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports